webpackJsonp([6498579462361],{

/***/ 989:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0009_forgotten_fighter.jpg","type":"Minor Spell","subtype":"Bounce","cost":2,"ATK":null,"HP":null,"rules_text_1":"Return a patrolling tech 0 or I unit with 2 ATK or less to its owner's hand.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Forgotten Fighter","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Purple","spec":null,"bottom":"Magic","rulings":[],"keywords":[],"slug":"forgotten_fighter"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"forgotten_fighter","keywords":[],"imageRegex":"/forgotten_fighter.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-forgotten-fighter-76a13ebd3fd55155f6f1.js